<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :collapse="true">
      <template slot="header">搜索</template>

      <el-form :model="search"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()"
               ref="searchForm">
        <div class="re-el-form__flex">
          <el-form-item label="客户名称" prop="keyword">
            <el-input placeholder="请输入客户名称"
                      v-model="search.keyword"
                      clearable />
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     size="mini">搜索
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="80" />
        <el-table-column prop="number"
                         label="客户编号"
                         min-width="100" />
        <el-table-column prop="name"
                         label="客户名称"
                         min-width="150" />
        <el-table-column fixed="right"
                         label="操作" width="440">
          <template slot-scope="scope">
            <button-gutter>
              <router-link :to="`/group-batch/table/${scope.row.id}`">
                <el-button type="primary" size="mini">群组批次</el-button>
              </router-link>
              <router-link :to="`/group-batch/market-table/${scope.row.id}`">
                <el-button type="primary" size="mini">客户群组门店关系</el-button>
              </router-link>
              <el-button type="success"
                         size="mini"
                         @click="openProjectMarketDialog(scope.row)">项目群组门店关系</el-button>
            </button-gutter>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <el-dialog title="选择项目"
               :visible.sync="projectDialog.visible"
               width="480px"
               @closed="resetProjectDialog">
      <el-form label-width="96px" size="medium">
        <el-form-item label="客户">
          <span>{{ projectDialog.customerName }}</span>
        </el-form-item>
        <el-form-item label="项目" required>
          <remote-select
            id-key="number"
            label-key="name"
            value-key="id"
            placeholder="请输入项目名称/编号搜索"
            v-model="projectDialog.projectid"
            :query-request="getBaiscProjectTable"
            :query-params="{customerid: projectDialog.customerId}"
            :find-request="getProjectDetail"
            clearable>
          </remote-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="projectDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="goProjectMarketTable">进入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  components: {},
  data () {
    return {
      search: {
        show_filter: '',
        keyword: '',
        type: this.$route.params.type || null
      },
      optionModel: {
        customerType: [],
      },
      uploadDialogVisible: false,
      projectDialog: {
        visible: false,
        customerId: null,
        customerName: '',
        projectid: null,
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.customer.options,
    }),
  },

  created () {
  },

  methods: {
    ...Vuex.mapActions([]),
    ...request.map(['getBaiscProjectTable', 'getProjectDetail']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      params = filter.copyJson(params)
      return request.page('getCustomerTable', params)
    },
    formatDate (value) {
      return filter.formatUnix(value)
    },
    openProjectMarketDialog (row) {
      this.projectDialog = {
        visible: true,
        customerId: row.id,
        customerName: row.name,
        projectid: null,
      }
    },
    resetProjectDialog () {
      this.projectDialog = {
        visible: false,
        customerId: null,
        customerName: '',
        projectid: null,
      }
    },
    goProjectMarketTable () {
      if (!this.projectDialog.projectid) {
        this.$message.error('请选择项目')
        return
      }
      const customerId = this.projectDialog.customerId
      const projectId = this.projectDialog.projectid
      this.projectDialog.visible = false
      this.$router.push(`/group-batch/market-table/${customerId}/project/${projectId}`)
    },
  },
}
</script>

<style lang="scss"
       scoped>
.link {
  color: #409EFF;
  padding: 5px 10px;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/group-batch/pages/GroupBatchCustomerTable.vue